import { useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Stack,
  Card,
  CircularProgress,
} from "@mui/material";
import "./styles.css";
import Sample from "../../assets/template/transliteration_sample.csv";
import SuccessModal from "./SuccessModal";
import HistoryIcon from "@mui/icons-material/History";
import Progress from "../bulk-operations/Progress";
import {
  TRANSLITERATION_CONSTANTS,
  BUTTONS,
} from "../../Constant/BulkOpsContant";
import {
  createRecordAwareChunks,
  uploadChunk,
} from "../../service/bulkServices";
import Dropzone from "../dropzone/Dropzone";
import { useHistory } from "react-router-dom";

const Transliteration = ({}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({
    current: 0,
    total: 0,
  });
  const fileInputRef = useRef(null);
  const history = useHistory();

  const handleClickUpload = async () => {
    if (!selectedFile) {
      return;
    }
    setIsUploading(true);
    setUploadProgress({ current: 0, total: 0 });
    try {
      const chunks = await createRecordAwareChunks(
        selectedFile,
        "transliteration",
        "null",
        "",
        "",
      );
      const totalChunks = chunks.length;
      setUploadProgress({ current: 0, total: totalChunks });
      let uniqueID;
      let createdAt;
      for (let i = 0; i < chunks.length; i++) {
        const getData = await uploadChunk(
          chunks[i],
          i,
          totalChunks,
          "null",
          selectedFile,
          uniqueID,
          "TRANSLITERATION",
          createdAt,
          "null",
          chunks[i].lastRowNo,
          chunks[i].firstRowNo,
          "null",
          "null",
        );
        // Update progress after each chunk
        if (i === 0) {
          uniqueID = getData.uploadId;
          createdAt = getData.createdAt;
        }
        const progressCurrent = i + 1;
        setUploadProgress({ current: progressCurrent, total: totalChunks });
        if (i < chunks.length - 1) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
      }
      setTimeout(() => {
        setIsUploading(false);
        setSelectedFile(null);
        setUploadProgress({ current: 0, total: 0 });
        setShowSuccessModal(true);
      }, 1500);
    } catch (error) {
      setErrorMessage(error.message || "An error occurred during upload");
      setIsUploading(false);
      setUploadProgress({ current: 0, total: 0 });
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="container body-height extra-margin-top-less mb-4">
      <Card sx={{ maxWidth: 800 }} className="mx-auto">
        <div className="m-5">
          <Paper elevation={0}>
            <Box className="main-container-box mb-4">
              <Typography variant="h5" className="fw-bold _wg-dynamic-text">
                {TRANSLITERATION_CONSTANTS.HEADING}
              </Typography>
              <Button
                variant="text"
                startIcon={<HistoryIcon />}
                size="small"
                color="error"
                onClick={() =>
                  history.push("/upload-history", {
                    defaultTab: "TRANSLITERATION",
                  })
                }
              >
                {BUTTONS.VIEW_HISTORY}
              </Button>
            </Box>
            <Typography
              variant="body1"
              paragraph
              className="mb-4 _wg-dynamic-text"
            >
              {TRANSLITERATION_CONSTANTS.SUB_HEADING}
            </Typography>
            <Box>
              <Stack>
                <Dropzone
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  error={errorMessage}
                  setError={setErrorMessage}
                  templateUrl={Sample}
                  allowedFormats=".csv"
                  typeUpload="translitration"
                  searchType=""
                  searchIn=""
                />
              </Stack>
            </Box>
            <div className="text-end">
              <Button
                variant="contained"
                onClick={handleClickUpload}
                disabled={!selectedFile || isUploading}
                className="_wg-dynamic-text mt-4 upload-btn rounded-md"
                color="error"
              >
                {isUploading ? (
                  <CircularProgress size={24} style={{ color: "#ffff" }} />
                ) : (
                  TRANSLITERATION_CONSTANTS.SUBMIT_BUTTON
                )}
              </Button>
            </div>
          </Paper>
        </div>

        <Progress open={isUploading} uploadProgress={uploadProgress} />
        {showSuccessModal && (
          <SuccessModal
            open={showSuccessModal}
            onClose={handleSuccessModalClose}
          />
        )}
      </Card>
    </div>
  );
};

export default Transliteration;
